import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thanetopunecab() {



const cardData = {
  keyword: "  Thane to Pune Cabs  ",

headingDescription: "Velocity Cab provides reliable and comfortable Thane to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Thane to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Thane to Pune cab travel.",

topPlaces: [
  
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Its peaceful surroundings and historic architecture make it a unique spiritual and heritage site in Pune."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gates, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its lush greenery and the Siddhivinayak Temple located inside it. It is a peaceful spot for families, morning walkers, and visitors looking for relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering boating facilities, green lawns, and walking tracks. It is a great place for relaxation and leisure activities in the heart of Pune."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks, known for its role in India’s freedom movement. Travelers booking a sedan cab in Pune can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi, making it a must-visit cultural and heritage site."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is a famous spiritual destination in Pune dedicated to Lord Ganesha. Visitors can experience divine blessings, admire the beautifully decorated idol, and enjoy the vibrant atmosphere, especially during Ganesh Chaturthi celebrations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases an extensive collection of Indian artifacts, including sculptures, musical instruments, and traditional objects. It offers visitors a deep insight into India’s cultural heritage and artistic excellence."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic landmark in Pune offering panoramic views of the city from its hilltop temples. Travelers can climb the steps to explore ancient shrines and enjoy a peaceful environment surrounded by natural beauty."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden featuring serene landscapes, water streams, and walking paths. It is a perfect place for relaxation, photography, and nature walks."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a major shopping and entertainment hub featuring top brands, restaurants, cinemas, and entertainment zones. It is a popular destination for shopping and leisure activities."
  }
],



services: [
{
name: "Thane to Pune Cab",
description: "Thane to Pune cab service offers reliable and comfortable intercity travel between Thane and Pune with smooth connectivity via the Mumbai–Pune Expressway. Travelers can choose from a wide range of vehicles including sedan, Ertiga, and Innova Crysta depending on comfort and group size. Professional drivers provide timely pickups from Thane West, Thane East, and nearby areas including residential societies, offices, and railway stations. This service is widely used by corporate professionals, families, and tourists traveling between the two cities. Air-conditioned vehicles with spacious seating ensure a relaxing long-distance journey. Online booking options provide instant confirmation, transparent pricing, and flexible scheduling for a hassle-free travel experience."
},
{
name: "Thane to Pune Taxi",
description: "Thane to Pune taxi service provides convenient and dependable transportation between the two cities. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers ensure safe driving and punctual pickup services from homes, offices, and hotels across Thane. This service is ideal for airport transfers, corporate travel, and personal trips to Pune. Comfortable interiors and air-conditioning make long-distance travel easy and relaxing."
},
{
name: "Thane to Pune Station Cab Fare",
description: "Thane to Pune station cab service offers reliable transportation for passengers traveling to Pune Railway Station. Travelers can book comfortable taxis for smooth highway travel with professional drivers ensuring timely pickups from Thane locations. Vehicles such as sedan, Ertiga, and Innova are available to suit different travel needs. This service is ideal for passengers connecting train journeys with intercity cab travel."
},
{
name: "Thane to Pune One Way Cab",
description: "Thane to Pune one way cab service provides economical travel for passengers who need a single-direction trip between Thane and Pune. Travelers benefit from affordable pricing as they only pay for one-way travel. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway journeys with professional drivers providing safe and timely service."
},
{
name: "Thane to Pune Ertiga Cab",
description: "Thane to Pune Ertiga cab service offers spacious 7-seater SUV travel for families and small groups. The Maruti Ertiga provides comfortable seating, air-conditioning, and smooth highway performance. Professional drivers ensure punctual pickups from Thane and safe driving through the expressway. This service is ideal for group travel, family trips, and airport transfers."
},
{
name: "Thane to Pune One Way Taxi",
description: "Thane to Pune one way taxi service provides affordable and convenient travel for passengers requiring single-direction transportation. Travelers can enjoy comfortable rides in well-maintained vehicles with professional drivers ensuring safe and smooth highway travel."
},
{
name: "Thane to Pimpri Chinchwad Cab Fare",
description: "Thane to Pimpri Chinchwad cab service provides dependable transportation between Thane and the PCMC region of Pune. Travelers can book sedan, Ertiga, or Innova vehicles for smooth expressway travel. Professional drivers provide punctual pickups and safe driving. This service is widely used by corporate travelers visiting industrial zones and offices in Pimpri Chinchwad."
},
{
name: "Thane to Pune Cab Service",
description: "Thane to Pune cab service offers reliable intercity travel with comfortable vehicles and professional drivers. Travelers can book taxis easily for smooth expressway journeys between Thane and Pune with convenient pickup options."
},
{
name: "Thane to Pune Innova Cab Service",
description: "Thane to Pune Innova cab service provides premium SUV transportation for travelers seeking comfort and space. The Toyota Innova offers excellent suspension, spacious seating, and smooth highway performance. Professional drivers ensure safe driving and punctual pickups from Thane."
},
{
name: "Mulund to Pune Taxi Fare",
description: "Mulund to Pune taxi service offers convenient transportation between Mulund in Mumbai and Pune city. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova for smooth highway travel. Professional drivers provide punctual pickups and safe driving through the expressway."
},
{
name: "Cab Service in Thane",
description: "Cab service in Thane provides reliable transportation for city travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for safe and convenient travel across Thane and nearby cities including Pune."
},
{
name: "Thane to Pune Round Trip Cab Service",
description: "Thane to Pune round trip cab service offers convenient travel for passengers requiring both onward and return journeys. Travelers can book vehicles with drivers available for the entire trip. This service is ideal for business meetings, family visits, and weekend travel."
},
{
name: "Thane to Baner Cab Fare",
description: "Thane to Baner cab service provides convenient transportation between Thane and Baner in Pune. Travelers can enjoy comfortable rides in well-maintained vehicles with professional drivers ensuring safe and smooth expressway travel."
},
{
name: "Outstation Taxi Service in Thane",
description: "Outstation taxi service in Thane provides reliable long-distance transportation to destinations such as Pune, Nashik, Lonavala, and Shirdi. Travelers can book comfortable vehicles with professional drivers for safe travel."
},
{
name: "Best Outstation Taxi Service in Thane",
description: "Best outstation taxi service in Thane offers premium transportation with well-maintained vehicles and experienced drivers. Travelers can enjoy comfortable rides for long-distance journeys to Pune and other nearby destinations."
},
{
name: "Best Outstation Taxi Service in Thane Contact Number",
description: "Best outstation taxi service in Thane contact number helps passengers quickly connect with reliable cab providers for booking taxis. Travelers can easily arrange comfortable rides for Pune trips and other outstation travel."
},
{
name: "Best Outstation Cab Service in Mumbai",
description: "Best outstation cab service in Mumbai provides dependable long-distance transportation to cities such as Pune, Nashik, and Lonavala. Travelers can book comfortable vehicles with professional drivers for safe travel."
},
{
name: "Taxi Service in Thane West",
description: "Taxi service in Thane West offers reliable transportation for local travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for convenient travel."
},
{
name: "Thane to Pune Taxi Booking",
description: "Thane to Pune taxi booking allows passengers to easily reserve taxis online with instant confirmation and transparent pricing. Travelers can choose vehicles based on comfort and travel needs."
},
{
name: "Thane to Pune Drop Taxi",
description: "Thane to Pune drop taxi service offers convenient one-way transportation between Thane and Pune with comfortable vehicles and affordable fares."
}
],

tableData: [
["Thane to Pune Cab","Thane to Pune Taxi"],
["Thane to Pune Station Cab Fare","Thane to Pune One Way Cab"],
["Thane to Pune Ertiga Cab","Thane to Pune One Way Taxi"],
["Thane to Pimpri Chinchwad Cab Fare","Thane to Pune Cab Service"],
["Thane to Pune Innova Cab Service","Mulund to Pune Taxi Fare"],
["Cab Service in Thane","Thane to Pune Round Trip Cab Service"],
["Thane to Baner Cab Fare","Outstation Taxi Service in Thane"],
["Best Outstation Taxi Service in Thane","Best Outstation Taxi Service in Thane Contact Number"],
["Best Outstation Cab Service in Mumbai","Taxi Service in Thane West"],
["Thane to Pune Taxi Booking","Thane to Pune Drop Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Thane to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Thane to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Thane to Pune cab service operates 24 hours a day. Whether you need an early morning ride, office commute, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Thane to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Thane",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Thane including Ghodbunder Road, Wagle Estate, Kalyan, Dombivli, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Thane to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Thane to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Thane to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Thane from Pune?", answer: "The road distance between Thane and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Thane to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Thane to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Thane to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Thane and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Thane." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Thane to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul More",
    feedback:
      "Thane to Pune cab service with Velocity Cab was very smooth and comfortable. The car was clean, and the journey was completed safely and on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Thane to Pune cab ride with Velocity Cab was excellent. The driver was professional, and the overall travel experience was hassle-free and comfortable.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Pune Cab Service | Velocity Cabs",
  "description": "Book Thane to Pune taxi with Velocity Cabs. One way, round trip, and airport transfer cabs available including Innova, Innova Crysta, Ertiga, and Sedan. Reliable, safe, and affordable cab service from Thane, Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  }
};




  return (
    <div>
      <Helmet>
  <title>Thane to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta
    name="description"
    content="Book Thane to Pune cab with Velocity Cabs. One way & round trip cabs including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, corporate trips & city travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thanetopunecab;